import type { TransactionDetails, TransactionInfo } from '@safe-global/safe-gateway-typescript-sdk'
import { TransactionStatus } from '@safe-global/safe-gateway-typescript-sdk'
import type { SafeTransaction } from '@safe-global/safe-core-sdk-types'

const proposeTx = async (
  chainId: string,
  safeAddress: string,
  sender: string,
  tx: SafeTransaction,
  safeTxHash: string,
  origin?: string,
): Promise<TransactionDetails> => {
  const signatures = tx.signatures.size ? tx.encodedSignatures() : undefined

  // return proposeTransaction(chainId, safeAddress, {
  //   ...tx.data,
  //   safeTxHash,
  //   sender,
  //   value: tx.data.value.toString(),
  //   operation: tx.data.operation as unknown as Operation,
  //   nonce: tx.data.nonce.toString(),
  //   safeTxGas: tx.data.safeTxGas.toString(),
  //   baseGas: tx.data.baseGas.toString(),
  //   gasPrice: tx.data.gasPrice.toString(),
  //   signature: signatures,
  //   origin,
  // })

  const txDetails: TransactionDetails = {
    safeAddress,
    txId: `multisig_${safeAddress}_${safeTxHash}`,
    txInfo: {} as TransactionInfo,
    txStatus: TransactionStatus.AWAITING_CONFIRMATIONS,
  }
  return txDetails
}

export default proposeTx

const request = {
  to: '0x7d5EF802785ad840712f3e39a186E0678263FCBa',
  value: '1000000000000000',
  data: '0x',
  operation: 0,
  baseGas: '0',
  gasPrice: '0',
  gasToken: '0x0000000000000000000000000000000000000000',
  refundReceiver: '0x0000000000000000000000000000000000000000',
  nonce: '0',
  safeTxGas: '0',
  safeTxHash: '0xd7162469db6420cd9157019c7fc44749d7150974dd4b79f3a3be9110fd571af8',
  sender: '0x7d5EF802785ad840712f3e39a186E0678263FCBa',
}

const response = {
  safeAddress: '0x3822bF7905C8E77F426Adf5f39e7985Ee59294DD',
  txId: 'multisig_0x3822bF7905C8E77F426Adf5f39e7985Ee59294DD_0xd7162469db6420cd9157019c7fc44749d7150974dd4b79f3a3be9110fd571af8',
  executedAt: null,
  txStatus: 'AWAITING_CONFIRMATIONS',
  txInfo: {
    type: 'Transfer',
    humanDescription: null,
    sender: {
      value: '0x3822bF7905C8E77F426Adf5f39e7985Ee59294DD',
      name: null,
      logoUri: null,
    },
    recipient: {
      value: '0x7d5EF802785ad840712f3e39a186E0678263FCBa',
      name: null,
      logoUri: null,
    },
    direction: 'OUTGOING',
    transferInfo: {
      type: 'NATIVE_COIN',
      value: '1000000000000000',
    },
  },
  txData: {
    hexData: null,
    dataDecoded: null,
    to: {
      value: '0x7d5EF802785ad840712f3e39a186E0678263FCBa',
      name: null,
      logoUri: null,
    },
    value: '1000000000000000',
    operation: 0,
    trustedDelegateCallTarget: null,
    addressInfoIndex: null,
  },
  txHash: null,
  detailedExecutionInfo: {
    type: 'MULTISIG',
    submittedAt: 1709469369888,
    nonce: 0,
    safeTxGas: '0',
    baseGas: '0',
    gasPrice: '0',
    gasToken: '0x0000000000000000000000000000000000000000',
    refundReceiver: {
      value: '0x0000000000000000000000000000000000000000',
      name: null,
      logoUri: null,
    },
    safeTxHash: '0xd7162469db6420cd9157019c7fc44749d7150974dd4b79f3a3be9110fd571af8',
    executor: null,
    signers: [
      {
        value: '0x7d5EF802785ad840712f3e39a186E0678263FCBa',
        name: null,
        logoUri: null,
      },
    ],
    confirmationsRequired: 1,
    confirmations: [],
    rejectors: [],
    gasTokenInfo: null,
    trusted: false,
  },
  safeAppInfo: null,
}
